import { Typography } from "@timeedit/ui-components";
import { translations } from "@timeedit/registration-shared";
import "./conflict.scss";
import ScheduleConflict from "@timeedit/ui-components/icons/ScheduleConflict";

type ConflictNotificationProps = {
  useText?: boolean;
  className?: string;
  text?: string;
  ids?: number[];
};

export function ConflictNotification({
  useText,
  text,
  ids,
}: ConflictNotificationProps): React.JSX.Element {
  return (
    <div data-reservation-ids={ids}>
      <ScheduleConflict
        alt="Schedule Conflict"
        className="conflict-notification__svg"
      />
      {useText && (
        <Typography.Text className="conflict-notification__text">
          {translations.conflict} {text}
        </Typography.Text>
      )}
    </div>
  );
}
